import React from 'react';
import {connect} from "react-redux";
import Icon from "../../../../../../../../../../components/icon";
import {msgCommentBar} from "../../../../../../../../../../../actions/msgBarActions";
import "./index.css";

class MsgCommentBar extends React.Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(){
        this.props.setMsgCommentBar([]);
    }

    render() {
        return (
            <div className={`d-flex align-items-center justify-content-center msg-comment-bar${this.props.msgCommentBar[0] ? ' ' + this.props.msgCommentBar[0] : ''}`}>
                {
                    this.props.msgCommentBar[1]
                        ?
                        <p className="m-0" dangerouslySetInnerHTML={{__html: this.props.msgCommentBar[1]}} />
                        :
                        ''
                }
                <Icon onClick={this.handleClick} name="times"/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        msgCommentBar: state.msgBarReducer.msgCommentBar
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setMsgCommentBar: (array) => {
            dispatch(msgCommentBar(array))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MsgCommentBar);